export enum eLenderPaid {
  LenderPaidSendingToSpruce = 'lender_paid_sending_to_spruce',
  LenderPaidNotSending = 'lender_paid_not_sending',
  TitlePaidNotSending = 'title_paid_not_sending',
  OtherNotSending = 'other_not_sending',
}
